/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimeOffsRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetTimeOffsResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getTimeOffs = (request: GetTimeOffsRequest, options?: CashRequestOptions) => post<GetTimeOffsRequest, GetTimeOffsResponse>("/2.0/cash/get-time-offs", request, {...options, rejectOnError: true })